import { useEffect } from "react";
import Cal, { getCalApi } from "@calcom/embed-react";
import "./contact.css";

const Contact = () => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: "30min" });
      cal("ui", {
        theme: "light",
        hideEventTypeDetails: false,
        layout: "month_view",
        cssVarsPerTheme: {
          light: {
            "cal-brand": "#c9a84c",
            "cal-brand-emphasis": "#a8893c",
            "cal-brand-text": "#ffffff",
            "cal-bg": "#ffffff",
            "cal-bg-subtle": "hsl(0,0%,98%)",
            "cal-bg-emphasis": "hsl(0,0%,93%)",
            "cal-bg-muted": "hsl(0,0%,96%)",
            "cal-text": "hsl(0,0%,20%)",
            "cal-text-emphasis": "hsl(0,0%,20%)",
            "cal-text-muted": "hsl(0,0%,46%)",
            "cal-border": "rgba(0,0,0,0.1)",
            "cal-border-subtle": "rgba(0,0,0,0.07)",
            "cal-border-emphasis": "rgba(0,0,0,0.18)",
            "cal-border-booker": "rgba(0,0,0,0.07)",
          },
        },
      });
    })();
  }, []);

  return (
    <section className="contact section" id="contact">
      <span className="section__eyebrow">Book a call</span>
      <h2 className="section__title">Get in touch</h2>

      <div className="contact__cal container">
        <Cal
          namespace="30min"
          calLink="contact-rishabhbanerjee/30min"
          style={{ width: "100%", height: "100%", overflow: "scroll" }}
          config={{ layout: "month_view", useSlotsViewOnSmallScreen: "true", name: "", email: "" }}
        />
      </div>
    </section>
  );
};

export default Contact;
